import { useHasMenu } from 'auth/access';
import { AnalystProjectList, EmployeeProjectList } from '../projects-list';

/**
 * Standalone projects list. The same lists appear on the role home screens; this
 * gives the sidebar's "Projects" entry a destination of its own. Chosen by menu grant like the
 * project page: the full list (`/api/analyst/jobs`) needs projects.projects EDIT, everyone
 * else sees the projects they have tasks on.
 */
export default function ProjectsPage() {
  const canManageProjects = useHasMenu('projects.projects', 'EDIT');

  return canManageProjects ? <AnalystProjectList /> : <EmployeeProjectList />;
}
